<template>
  <EuiContainer>
    <EuiGrid class="mx-0 mt-2">
      <searchCard
          title="Mise à jour de la question secrète"
          @reset-field="resetModifiedField"/>
      <EuiGridRow v-if="getterIsLaunch " class="mt-4">
        <EuiBlock title="Résultat">
          <template v-slot:actions>
            <form v-if="getterResult.length === 1"
                  @submit.prevent="validation">
              <EuiGridRow class="my-2"  justify="between" >
                <EuiGridColumn>
                  <EuiTextField
                      class="mx-6 w-80"
                      adaptSize
                      :value="explicitQuestion(getterResult[0].secretQuestion)"
                      disabled
                      label="Question actuelle"/>
                  <EuiTextField
                      adaptSize
                      class="mx-6 w-80"
                      :value="getterResult[0].answer"
                      disabled
                      label="Réponse actuelle"/>
                </EuiGridColumn>
                <EuiGridColumn>
                  <EuiTextField class="mx-6 w-80" adaptSize>
                    <EuiLabel>Question modifiée</EuiLabel>
                    <EuiSelect v-model="modifiedSecretQuestion" id="modifiedQuestion" >
                      <Option
                          v-for="question in getterListQuestions"
                          :key="question.id"
                          :value="question.id" >
                        {{question.question}}
                      </Option>
                    </EuiSelect>
                  </EuiTextField>
                  <EuiTextField
                      class="mx-6 w-80"
                      adaptSize
                      v-model="modifiedSecretAnswer"
                      label="Réponse"
                      required
                      placeholder="Réponse"/>
                </EuiGridColumn>
                <EuiGridColumn class="ml-2">
                  <EuiButton
                      class="ml-auto mr-2 my-auto"
                      color="primary" variant="raised"
                      type="submit"
                      :disabled="!isEnabledDialog">
                    Valider
                  </EuiButton>
                </EuiGridColumn>
              </EuiGridRow>
            </form>
          </template>
          <resultCard />
        </EuiBlock>
      </EuiGridRow>
    </EuiGrid>
    <ConfirmationDialog
        v-if="isEnabledDialog"
        :isOpen="isConfirmationDialogOpen"
        @confirmation="confirmation"
        @close-dialog="closeDialog">
      <span v-html="confirmationMessage"></span>
    </ConfirmationDialog>
  </EuiContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import searchCard from '@/components/searchCard.vue';
import resultCard from '@/components/resultCard.vue';
import ConfirmationDialog from '@/components/confirmationDialog.vue';

export default {
  name: 'pages.update.secret-question',
  components: {
    searchCard,
    resultCard,
    ConfirmationDialog,
  },
  data() {
    return {
      modifiedSecretQuestion: 1,
      modifiedSecretAnswer: '',
      isConfirmationDialogOpen: false,
      isUpdatedBoxe: false,
    };
  },
  mounted() {
    this.storeResetChangeRoute();
  },
  computed: {
    ...mapGetters({
      getterIsLaunch: 'application/isLaunch',
      getterResult: 'boxes/result',
      getterSession: 'auth/session',
      getterListQuestions: 'application/listQuestion',
    }),
    isEnabledDialog() {
      return this.getterResult.length === 1 && this.modifiedSecretQuestion !== '' && this.modifiedSecretAnswer !== '';
    },
    confirmationMessage() {
      return 'Confirmation du changement de l\'état actuel<br>'
          + `question: <b>${this.explicitQuestion(this.getterResult[0].secretQuestion)}</b>`
          + `- réponse <b>${this.getterResult[0].answer}</b><br>`
          + 'vers <br>'
          + `question: <b>${this.explicitQuestion(this.modifiedSecretQuestion)}</b> - réponse `
          + `<b>${this.modifiedSecretAnswer}</b> pour le coffre <b>${this.getterResult[0].userId}</b> ?`;
    },
  },
  methods: {
    ...mapActions({
      storeUpdateSecretQuestion: 'boxes/updateSecretQuestionBoxe',
      storeResetChangeRoute: 'application/resetChangeRoute',
      storeSearchMatches: 'boxes/getMatchesBoxes',
      storeStartLoading: 'application/startLoading',
      storeFinishLoading: 'application/finishLoading',
    }),
    closeDialog() {
      this.isConfirmationDialogOpen = false;
    },
    explicitQuestion(index = 1) {
      if (!this.getterListQuestions[index - 1]) {
        return 'Aucune';
      }
      return this.getterListQuestions[index - 1]
        .question;
    },
    confirmation() {
      this.closeDialog();
      this.storeStartLoading();
      this.storeUpdateSecretQuestion({
        sessionId: this.getterSession.token,
        userId: this.getterResult[0].userId,
        secretQuestion: this.modifiedSecretQuestion,
        answer: this.modifiedSecretAnswer,
      }).then(() => {
        this.modifiedSecretAnswer = '';
        this.modifiedSecretQuestion = 1;
        this.storeSearchMatches({
          userId: this.getterResult[0].userId,
          sessionId: this.getterSession.token,
        }).then(() => {
          this.isUpdatedBoxe = true;
          this.storeFinishLoading();
        });
      }).catch(() => {
        this.storeFinishLoading();
      });
    },
    validation() {
      this.isConfirmationDialogOpen = true;
    },
    resetModifiedField() {
      this.modifiedSecretQuestion = 1;
      this.modifiedSecretAnswer = '';
      this.isUpdatedBoxe = false;
    },
  },
};
</script>
